module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/annie-pendergast-ee1651d7c71150dff52e92098288e6cd.jpg";